import styled from "styled-components";
import { pxToRem } from "../../../styles/utils";

export const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
`;

export const ModalContent = styled.div`
  background: #fff;
  border-radius: ${pxToRem(16)};
  box-shadow: 0 ${pxToRem(4)} ${pxToRem(12)} rgba(0, 0, 0, 0.1);
  width: ${pxToRem(429)};
`;

export const ModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 ${pxToRem(30)};

  h2 {
    color: rgb(31, 10, 53);
    font-size: ${pxToRem(28)};
    font-weight: 700;
  }
`;

export const Divider = styled.div`
  width: 100%;
  height: ${pxToRem(1)};
  background-color: rgb(225, 224, 229);
`;

export const CloseButton = styled.button`
  background: none;
  border: none;
  width: ${pxToRem(24)};
  height: ${pxToRem(24)};
  font-size: ${pxToRem(24)};
  color: #ccc;
  cursor: pointer;

  &:hover {
    color: #000;
  }
`;

export const ModalBody = styled.div`
  padding: ${pxToRem(20)} ${pxToRem(30)};

  p {
    color: rgb(31, 10, 53);
    font-size: ${pxToRem(18)};
    font-weight: 500;
    margin-bottom: ${pxToRem(16)};
  }
`;

export const Description = styled.p`
  color: rgb(31, 10, 53);
  opacity: 0.5;
  margin-bottom: ${pxToRem(30)};
`;

export const RadioGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${pxToRem(12)};
  margin-bottom: ${pxToRem(16)};
  margin-top: ${pxToRem(35)};
`;

export const RadioOption = styled.div`
  label {
    display: flex;
    align-items: center;
    font-size: ${pxToRem(18)};
    font-weight: 500;
    color: rgb(31, 10, 53);
    cursor: pointer;
    position: relative;
    padding-left: ${pxToRem(40)}; /* Отступ для иконки */
    margin-bottom: ${pxToRem(10)};

    input {
      position: absolute;
      opacity: 0;
      cursor: pointer;
    }

    img {
      position: absolute;
      left: 0;
      top: 50%;
      transform: translateY(-50%);
      width: ${pxToRem(28)};
      height: ${pxToRem(28)};
      transition: all 0.5s ease;

      &:hover {
        transform: translateY(-60%);
      }
    }
  }
`;

export const TariffLink = styled.a`
  display: inline-block;
  color: rgb(114, 82, 220);
  font-size: ${pxToRem(18)};
  font-weight: 700;
  text-decoration: none;
  cursor: pointer;
`;

export const ModalFooter = styled.div`
  display: flex;
  justify-content: space-between;
  gap: ${pxToRem(16)};
  padding: ${pxToRem(16)} ${pxToRem(22)};
  padding-top: 0;

  button {
    flex: 1;
  }
`;
